import { trackEvent } from "@pb/utils/tracking";
import { trackOptimizelyVanillaEvent } from "@pb/utils/optimizely";
import { AbEvents } from '../optimizely/optimizelyConstants';
import trackingConstants from './trackingConstants';
const findMonkiBrand = (arr) => {
    return arr.some((product) => product.brandName === 'Monki');
};
const handleImpression = ({ event = 0, productSet, visibleItemsInCarousel, modelInfo, praConfiguration, origin, onShow, trackedProductsOnImpression, }) => {
    const position = event;
    const visibleProducts = productSet.slice(position, position + visibleItemsInCarousel);
    const { TRACKING, SOURCE, ID, PANEL_ID, TRACKING_ID } = praConfiguration;
    let amountOfVisibleUntrackedProducts = 0;
    let containsUntrackedProduct = false;
    const finalData = Object.assign(Object.assign({}, trackingConstants.IMPRESSION), { imp_list_name: TRACKING_ID || PANEL_ID || (ID && ID.toLowerCase()), imp_segment_type: [], event_type: onShow ? TRACKING.IMPRESSION : TRACKING.IMPRESSION_CLICK, imp_position: [], imp_id: [], imp_color: [], imp_category: [], imp_origin_system: [], imp_brand: [], imp_name: [], imp_article_id: [] });
    visibleProducts.forEach((product) => {
        const formattedArticleCode = `${product.articleCode}`;
        if (!formattedArticleCode || trackedProductsOnImpression.includes(formattedArticleCode)) {
            return;
        }
        const { articleCode, alternateColor, category, origin: productOrigin, brandName, title, articleInfo, } = product;
        trackedProductsOnImpression.push(formattedArticleCode);
        containsUntrackedProduct = true;
        amountOfVisibleUntrackedProducts += 1;
        finalData.imp_position.push(`${position + amountOfVisibleUntrackedProducts}`);
        finalData.imp_id.push(articleCode ? `${articleCode}`.substring(0, 7) : '');
        finalData.imp_color.push((alternateColor === null || alternateColor === void 0 ? void 0 : alternateColor.code) || '');
        finalData.imp_category.push(category ? `${category}`.toUpperCase() : '');
        finalData.imp_origin_system.push(productOrigin || ((origin === null || origin === void 0 ? void 0 : origin.length) && origin) || SOURCE || '');
        finalData.imp_brand.push(brandName || '');
        finalData.imp_name.push(title ? `${title}`.toUpperCase() : '');
        finalData.imp_segment_type.push(articleInfo || modelInfo || '');
        finalData.imp_article_id.push(articleCode ? `${articleCode}` : '');
    });
    if (containsUntrackedProduct) {
        trackEvent(finalData);
    }
    // Only for A/B testing purposes
    // TODO: remove when iterative testing of component is completed. PXREC-2968
    const trackOptimizelyViewEvents = (praType, products) => {
        const hasMonkiItem = findMonkiBrand(products);
        if (praType === 'SWG') {
            trackOptimizelyVanillaEvent(AbEvents.ON_VIEW_STYLE_WITH);
            if (hasMonkiItem)
                trackOptimizelyVanillaEvent(AbEvents.VIEW_PDP_PRA_STYLE_WITH_MONKI_ITEM);
        }
        else if (praType === 'PRA1') {
            trackOptimizelyVanillaEvent(AbEvents.ON_VIEW_OTHERS_ALSO_BOUGHT);
            if (hasMonkiItem)
                trackOptimizelyVanillaEvent(AbEvents.VIEW_PDP_PRA_OTHERS_ALSO_BOUGHT_MONKI_ITEM);
        }
        else if (praType === 'PRA2') {
            trackOptimizelyVanillaEvent(AbEvents.ON_VIEW_RELATED_ARTICLES);
            if (hasMonkiItem)
                trackOptimizelyVanillaEvent(AbEvents.ON_VIEW_RELATED_ARTICLES);
        }
        trackOptimizelyVanillaEvent(AbEvents.ON_VIEW_PDP_PRA_ITEM);
        if (hasMonkiItem)
            trackOptimizelyVanillaEvent(AbEvents.VIEW_PDP_PRA_MONKI_ITEM);
    };
    trackOptimizelyViewEvents(ID, productSet);
    return trackedProductsOnImpression;
};
export default handleImpression;
//# sourceMappingURL=handleImpression.js.map